var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.7973C2.5 6.62486 5.84465 3.27837 10.0042 3.27837C10.5221 3.27837 11.0229 3.33798 11.4643 3.42313L9.20628 1.18362C9.08744 1.04738 9.01952 0.877071 9.01952 0.698251C9.01952 0.306549 9.30815 0 9.69015 0C9.89389 0 10.0637 0.068122 10.1825 0.204366L13.68 3.76374C13.8158 3.89998 13.8922 4.08732 13.8922 4.27466C13.8922 4.47051 13.8328 4.64081 13.68 4.78557L10.1825 8.31088C10.0637 8.43861 9.90238 8.50674 9.69015 8.50674C9.30815 8.50674 9.01952 8.21722 9.01952 7.82552C9.01952 7.64669 9.08744 7.47639 9.21477 7.34015L11.753 4.81963C11.2521 4.70042 10.6494 4.64933 10.0042 4.64933C6.60017 4.64933 3.86672 7.38272 3.86672 10.7973C3.86672 14.2205 6.60017 16.9624 10.0042 16.9624C13.4083 16.9624 16.1333 14.2205 16.1333 10.7973C16.1333 10.3886 16.3964 10.0906 16.7954 10.0906C17.2114 10.0906 17.5 10.3886 17.5 10.7973C17.5 14.9783 14.1638 18.3333 10.0042 18.3333C5.84465 18.3333 2.5 14.9783 2.5 10.7973Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.f8df3279aadcba7bd42307d34b04b795.svg";
export { ForwardRef as ReactComponent };